"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeleteCanSpamSetting = exports.deleteCanSpamSetting = exports.UpdateCanSpamSetting = exports.updateCanSpamSetting = exports.CreateCanSpamSetting = exports.createCanSpamSetting = exports.FetchCanSpamSettings = exports.loadCanSpamSettings = exports.DeleteCanSpamSettingActionTypes = exports.UpdateCanSpamSettingActionTypes = exports.CreateCanSpamSettingActionTypes = exports.FetchCanSpamSettingsActionTypes = exports.CanSpamSettingsActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var _constants = require("./constants");

var CanSpamSettingsActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_CAN_SPAM_SETTINGS: null,
  FETCH_CAN_SPAM_SETTINGS: null,
  CREATE_CAN_SPAM_SETTING: null,
  UPDATE_CAN_SPAM_SETTING: null,
  DELETE_CAN_SPAM_SETTING: null
}, _constants.CAN_SPAM_SETTING);
exports.CanSpamSettingsActionTypes = CanSpamSettingsActionTypes;
var FetchCanSpamSettingsActionTypes = (0, _actions.createRequestTypes)(CanSpamSettingsActionTypes.FETCH_CAN_SPAM_SETTINGS);
exports.FetchCanSpamSettingsActionTypes = FetchCanSpamSettingsActionTypes;
var CreateCanSpamSettingActionTypes = (0, _actions.createRequestTypes)(CanSpamSettingsActionTypes.CREATE_CAN_SPAM_SETTING);
exports.CreateCanSpamSettingActionTypes = CreateCanSpamSettingActionTypes;
var UpdateCanSpamSettingActionTypes = (0, _actions.createRequestTypes)(CanSpamSettingsActionTypes.UPDATE_CAN_SPAM_SETTING);
exports.UpdateCanSpamSettingActionTypes = UpdateCanSpamSettingActionTypes;
var DeleteCanSpamSettingActionTypes = (0, _actions.createRequestTypes)(CanSpamSettingsActionTypes.DELETE_CAN_SPAM_SETTING);
exports.DeleteCanSpamSettingActionTypes = DeleteCanSpamSettingActionTypes;
var loadCanSpamSettings = (0, _fluxActions.createAction)(CanSpamSettingsActionTypes.LOAD_CAN_SPAM_SETTINGS);
exports.loadCanSpamSettings = loadCanSpamSettings;
var FetchCanSpamSettings = (0, _actions.createRequestActions)(FetchCanSpamSettingsActionTypes);
exports.FetchCanSpamSettings = FetchCanSpamSettings;
var createCanSpamSetting = (0, _fluxActions.createAction)(CanSpamSettingsActionTypes.CREATE_CAN_SPAM_SETTING, (0, _actions.mapPayloadTo)('data'));
exports.createCanSpamSetting = createCanSpamSetting;
var CreateCanSpamSetting = (0, _actions.createRequestActions)(CreateCanSpamSettingActionTypes);
exports.CreateCanSpamSetting = CreateCanSpamSetting;
var updateCanSpamSetting = (0, _fluxActions.createAction)(CanSpamSettingsActionTypes.UPDATE_CAN_SPAM_SETTING, (0, _actions.mapPayloadTo)('data'));
exports.updateCanSpamSetting = updateCanSpamSetting;
var UpdateCanSpamSetting = (0, _actions.createRequestActions)(UpdateCanSpamSettingActionTypes);
exports.UpdateCanSpamSetting = UpdateCanSpamSetting;
var deleteCanSpamSetting = (0, _fluxActions.createAction)(CanSpamSettingsActionTypes.DELETE_CAN_SPAM_SETTING, (0, _actions.mapPayloadTo)('id'));
exports.deleteCanSpamSetting = deleteCanSpamSetting;
var DeleteCanSpamSetting = (0, _actions.createRequestActions)(DeleteCanSpamSettingActionTypes);
exports.DeleteCanSpamSetting = DeleteCanSpamSetting;